import { Document, Page } from 'react-pdf/dist/esm/entry.webpack';
import resumePDF from '../images/SonalPrasadResume.pdf';
import React from "react";
import { Row } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import { AiOutlineDownload } from "react-icons/ai";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import 'react-pdf/dist/esm/Page/TextLayer.css';
import "../styles/resume.css";

function Resume () {

  return (
  	<div>
  	  <h1>Resume</h1>
  	  <Row style={{ justifyContent: "center", position: "relative" }} className="download">
        <Button
            variant="primary"
            href={resumePDF}
            target="_blank"
            style={{ maxWidth: "250px" }}
        >
            <AiOutlineDownload />
            Download Resume
        </Button>
        </Row>
  	  <Row style={{ justifyContent: "center", position: "relative" }} className="document">
  	    <Document file={resumePDF}>
          <Page pageNumber={1} scale={1.5} />
        </Document>
      </Row>
    </div>
  );
}

export default Resume;


/*
This chunk of code works and uses the PdfViewer
*/
// import React, { useState, useEffect } from 'react';
// import { Document, Page, pdfjs } from 'react-pdf';
// import resumePDF from '../images/SonalPrasadResume.pdf';
// import { Container, Row } from "react-bootstrap";
// import Button from "react-bootstrap/Button";
// import { AiOutlineDownload } from "react-icons/ai";
// import PdfViewer from './PdfViewer'

// function Resume () {
//    const [showPdf, setShowPdf] = useState(false)
//    return (
//       <div className="resume">
//          <PdfViewer pdf={resumePDF}
//            onCancel={()=>setShowPdf(false)}
//            visible={showPdf}
//          />
//          <Button onClick={()=>setShowPdf(!showPdf)}>
//            Show PdfViewer
//          </Button>
//       </div>
//    );
// }
// export default Resume;

/*
This chunk of code works but it shows the PDFs twice
*/
// export default function Resume() {
      
//   pdfjs.GlobalWorkerOptions.workerSrc = 
//   `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
//   const [numPages, setNumPages] = useState(null);
//   const [pageNumber, setPageNumber] = useState(1);

//   function onDocumentLoadSuccess({ numPages }) {
//     setNumPages(numPages);
//     setPageNumber(1);
//   }
//   return (
//   	<>
//       <div className="main">
//         <Row style={{ justifyContent: "center", position: "relative" }} className="document">
//           <Document
//             file={resumePDF}
//             onLoadSuccess={onDocumentLoadSuccess}
//             >
//             <Page pageNumber={pageNumber} />
//           </Document>
//         </Row>
//         <Row style={{ justifyContent: "center", position: "relative" }}>
//           <Button
//             variant="primary"
//             href={resumePDF}
//             target="_blank"
//             style={{ maxWidth: "250px" }}
//           >
//             <AiOutlineDownload />
//             Download Resume
//           </Button>
//         </Row>
//       </div>
//     </>
//   );
// }



// import { Document, Page, pdfjs } from 'react-pdf/dist/esm/entry.webpack';
// import resumePDF from '../images/SonalPrasadResume.pdf';
// import React, { useState, useEffect } from "react";
// import { Container, Row } from "react-bootstrap";
// import Button from "react-bootstrap/Button";
// import { AiOutlineDownload } from "react-icons/ai";
// import "react-pdf/dist/esm/Page/AnnotationLayer.css";

// function Resume () {

//   return (
//     <div>
//       <Container fluid className="resume-section">
//         <Row className="resume">
//           <object width="80%" height="1000px" data={resumePDF} type="application/pdf">   
//           </object>
//         </Row>
        // <Row style={{ justifyContent: "center", position: "relative" }}>
        //   <Button
        //     variant="primary"
        //     href={resumePDF}
        //     target="_blank"
        //     style={{ maxWidth: "250px" }}
        //   >
        //     <AiOutlineDownload />
        //     Download Resume
        //   </Button>
        // </Row>
//       </Container>
//     </div>
//   );
// }

// export default Resume;

// function Resume() {
// 	return (
// 	  <div>
// 	      <div>
// 		    <h1>Resume</h1>
// 		  </div>
// 		  <div>
// 		    <Document file={resumePDF}>
// 	        </Document>
// 	      </div>
// 	  </div>
// 	);
// }

// export default Resume;